import { Component, OnDestroy, OnInit } from '@angular/core';
import { Share } from '@capacitor/share/dist/esm';
import { OrganizerService } from 'src/app/services/organizer.service';
import { Router } from '@angular/router';
import { ExperienceService } from 'src/app/services/experience.service';
import { MarkersExperience, typeExperience } from 'src/app/models/ToursModels';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-experience-map-card',
  templateUrl: './experience-map-card.component.html',
  styleUrls: ['./experience-map-card.component.scss'],
})
export class ExperienceMapCardComponent implements OnInit, OnDestroy {
  markerExperienceSelected: MarkersExperience;
  iSMinicardShowed: boolean = false;
  public typeExperience = typeExperience;
  private unsubscribe$ = new Subject<void>();

  constructor(
    public ORGService: OrganizerService,
    private router: Router,
    private experienceService: ExperienceService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.experienceService.$markerExperienceSelected
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((selected) => {
      if (selected) {
        this.markerExperienceSelected = selected;
      }
    });

    this.ORGService.$isCarouselExperienceOpen
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(
      (shouldDisplayCard) => {
        this.iSMinicardShowed = shouldDisplayCard;
      }
    );
  }

  async onShare() {
    const prodUrl = 'https://med.miradores.co';
    let url = `${prodUrl}/experience/${this.markerExperienceSelected.experience._id}`;
    await Share.share({
      title: 'Miradores Medellín',
      text: this.markerExperienceSelected.experience.title,
      url: url,
      dialogTitle: 'Miradores Medellín',
    });
  }

  seeDetail(markerExperience: MarkersExperience) {
    this.router.navigate([`/experience/${markerExperience.experience._id}`]);
  }

  closeCard() {
    this.ORGService.setCarruselExperienceStatus('close');
  }

  
ngOnDestroy(): void {
  this.unsubscribe$.next();
  this.unsubscribe$.complete();
}

}
